import { service } from "node-back-client/src/services/api";

let isCalled = false;
let url = process.env.VUE_APP_REGION_URL;
let apis = {};

class regions {

    async getRecords(recordTitle = "") {
        if (isCalled) return apis;

        let serv = service(url, recordTitle);
        let records = await serv.get("");
        
        apis = records;
        isCalled = true;
        
        return records;
    }
}

export const reg = new regions();